<div class="blue pt-4 my-0 intro-banner">
<div class="container">
    <div class="row d-flex align-items-center">
        <div class="col-md-5 col-12 px-3">
            <div class="first-block text">
                <h1 id="titre"><span class="bold">{{'Journée Sécurité' | translate}}</span> - {{'Marquez les esprits et réveillez les consciences' | translate}} </h1>
                <p class="mt-3">{{'Organiser des journées sécurité est un moyen de vous assurer que votre équipe travaille en toute sécurité.' | translate}}</p>
                <div class="mb-3 mb-md-0 mt-4">
                    <button class="btn btn-immersive btn-rounded" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Journée sécurité')}" title="contact"><i class="fas fa-envelope mr-2"></i>{{'Contact us' | translate}}</button>
                </div>
            </div>
        </div>
        <div class="col-md-7 col-12 mt-md-0 mt-3">
            <div class="first-block pic">
                <picture>
                    <source srcset="assets/man-vr-immersive.webp" type="image/webp">
                    <source srcset="assets/man-vr-immersive.png" type="image/png">
                    <img src="assets/man-vr-immersive.png" alt="A man wearing a virtual reality headset" title="Safety Day" loading="lazy">
                </picture>
            </div>
        </div>
    </div>
</div>
</div>


<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mx-auto" style="max-width: 1400px;width:75%;" role="document">
    <div class="modal-content">
      <i data-dismiss="modal" class="close fas fa-times-circle"></i>
      <div class="modal-body">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" [src]="videoSrc" id="video"  allowscriptaccess="always" allow="autoplay" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="blue pt-4 my-0 intro-banner position-relative">
  <div class="position-absolute" style="bottom:0px;left: 50%;transform: translate(-50%);width:100%;">
<div class="container">
    <div class="row d-flex align-items-center">
        <div class="col-md-5 col-12 px-3">
            <div class="first-block text">
                <h1 id="titre">{{'Marquez les esprits et réveillez les consciences avec votre' | translate}} <span class="bold">{{'Journée Sécurité' | translate}}</span></h1>
                <p class="mt-3">{{'Organiser des journées sécurité est un moyen de vous assurer que votre équipe travaille en toute sécurité.' | translate}}</p>
                <div class="mb-3 mb-md-0 mt-4">
                    <button class="btn btn-immersive btn-rounded" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Journée sécurité')}"><i class="fas fa-envelope mr-2"></i>{{'Contact us' | translate}}</button>
                </div>
            </div>
        </div>
        <div class="col-md-7 col-12 mt-md-0 mt-3">
            <div class="first-block pic">
                <img src="assets/homme_vr_transparent.png" alt="Organize Safety Day" style="min-width:100%;">
            </div>
        </div>
    </div>
</div>
</div>
</div> -->

<hr class="mt-0">


<div class="container my-5">
    <div class="text-center mb-md-5 ">
        <h2 class="title">{{'Animez votre Journée Sécurité' | translate}}</h2>
    </div>
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 mb-4">
          <div class="block-pricing sub-middle">
            <div class="block-header">{{'Animation journée sécurité' | translate}}</div>
            <div class="block-content">
              <div class="block-prices py-4">
                <div class="px-0">
                  <!-- <div class="mb-2"> -->
                  <div class="prices-loading" *ngIf="loading"></div>
                  <div class="prices-value animate__animated animate__fadeIn text-center" *ngIf="!loading">
                    <div class="price-workshop">
                      <span class="mr-1">{{basketService.currencySymbol}}</span>
                      <span>
                        <app-currency [currency]="basketService.currentCurrency" [currencyvalue]="1500"></app-currency>
                      </span>
                      <span class="ht"> {{'HT' | translate}}</span>
                    </div>
                    <!-- <div class="price-bottomline">{{'par journée' | translate}}</div> -->
                  </div>
                  <!-- </div> -->
                </div>
              </div>
              <div class="text-center mb-4">
                <picture>
                    <source srcset="assets/Tarifs_Abonnement_Animation_Journee_Securite.webp" type="image/webp">
                    <source srcset="assets/Tarifs_Abonnement_Animation_Journee_Securite.jpg" type="image/jpg">
                    <img src="assets/Tarifs_Abonnement_Animation_Journee_Securite.jpg" class="w-100" alt="picture of a safety day animation" title="Safety Day Animation" loading="lazy">
                </picture>
              </div>
              <div class="mb-4">
                <div class="feature-point"><i class="fa fa-check-circle" aria-hidden="true"></i>
                  <span>{{"Ateliers au choix" | translate }}</span>
                                        <span class="ml-1 fa-stack small dark-yellow" [routerLink]="language.navigateAccordingToLang(['/our-contributors'])" title="learn more">
                                            <i class="far fa-circle fa-stack-2x"></i>
                                            <i class="fas fa-info fa-stack-1x"></i>
                                        </span>
                </div>
                <div class="feature-point"><i class="fa fa-check-circle" aria-hidden="true"></i> {{"Votre consultant dédié" | translate }}</div> <!-- {{"Votre consultant dédié" | translate }} -->
                <div class="feature-point"><i class="fa fa-check-circle" aria-hidden="true"></i> {{"Son équipement VR complet" | translate }}</div> <!-- {{"Son équipement VR complet" | translate }} -->
                <div class="feature-point"><i class="fa fa-check-circle" aria-hidden="true"></i> {{"Environ 50 passages par consultant" | translate }}</div> <!-- {{"Environ 50 passages par consultant" | translate }} -->
                <div class="feature-point"><i class="fa fa-check-circle" aria-hidden="true"></i> {{"Atelier PC offert pour votre journée" | translate }}</div> <!-- {{"Atelier PC offert pour votre journée" | translate }} -->
              </div>
              <div class="text-center">
                <button class="btn btn-immersive d-inline-block" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Animation journée sécurité')}" title="subscribe"><i class="fas fa-sign-in-alt mr-2"></i>{{'Commander_' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 px-4 mb-4 justify-content-center text-justify">
          <div class="position-relative h-100">
            <div class="d-flex align-items-start flex-column mb-h-custom">
              <p class="bold my-auto">{{"Vous souhaitez sensibiliser vos collaborateurs pour vos formations, quarts d'heure sécurité, causeries... ?" | translate}}</p>
              <p class="my-auto">
                <span>{{'Demandez dès aujourd’hui la' | translate}}</span>
                <span class="bold">{{language.lang == 'en' ? ' Daily': ''}} SafetyBox {{language.lang == 'fr' ? 'Jour ': ''}}</span>
                <!-- <vr-logo size="20" class="d-inline-block" [style.width.px]="20" [style.margin-right.px]="2" [style.margin-left.px]="5"></vr-logo> -->
                <picture>
                    <source srcset="assets/vr_logo.webp" type="image/webp">
                    <source srcset="assets/vr_logo.png" type="image/png">
                    <img class="img-logo mx-1" src="assets/vr_logo.png" alt="VR logo" title="VR" loading="lazy">
                </picture>
                <span>®</span>
                <span> {{'et' | translate}} </span>
                <span class="bold">{{'animez vous même vos Journées Sécurité' | translate}}</span>.</p>
              <!-- <p class="text-justify my-auto">{{'Au programme de la Journée Sécurité offerte ? Notre consultant et son propre équipement VR' | translate}}, <span class="bold">{{'animation pour 50 apprenants' | translate}}</span>, {{'expertise HSE' | translate}}, <span class="bold">{{'formation pédagogique' | translate}}</span> {{'à l’utilisation de la VR et prise en main de votre' | translate}} <span class="bold">SafetyBox</span><img class="img-logo mx-1" src="assets/vr_logo.png">®.</p> -->
              <picture>
                  <source srcset="assets/{{'safetybox-vr-adverising-fr' | translate}}.webp" type="image/webp">
                  <source srcset="assets/{{'safetybox-vr-adverising-fr' | translate}}.jpg" type="image/jpg">
                  <img class="block-rounded shadow my-auto advertising" src="assets/{{'safetybox-vr-adverising-fr' | translate}}.jpg" alt="SafetyBoxVR advertising" title="SafetyBoxVR" loading="lazy">
              </picture>
            </div>
            <div class="position-absolute btn-safetybox text-center" style="position: absolute;">
                <button class="btn btn-red btn-immersive" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant(language.lang == 'fr' ? 'SafetyBox VR Jour': 'Daily SafetyBox VR')}" title="learn more"><i class="fas fa-sign-in-alt mr-2"></i>{{'En savoir plus' | translate}}</button>
            </div>
          </div>
        </div>
    </div>
</div>


<hr>

<div class="container my-5">
    <div class="text-center mb-md-5 ">
        <h2 class="title">{{'La journée sécurité VR' | translate}}</h2>
    </div>
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 mb-md-4 mb-4 justify-content-center">
            <p class="text-justify">{{'C’est un fait: on ne retient pas les informations données lors des formations trop théoriques. Partant de ce constat simple' | translate}}, <span class="bold">Immersive Factory</span> {{'a développé avec des experts de l’apprentissage une solution pour passer de' | translate}} <span class="text-bleu">{{'l’apprentissage passif à l’apprentissage immersif' | translate}}</span>.</p>
            <p class="text-justify">{{'Notre solution est un catalogue de plus de' | translate}} <span class="text-bleu">{{'30 serious games et ateliers en réalité virtuelle' | translate}}</span>: <i>{{'chasse aux anomalies, sensibilisation, co-activité et circulation…' | translate}}</i> {{'Nous avons un atelier VR précis pour chaque besoin pour vos' | translate}} <span class="bold">{{'journées sécurité sur site' | translate}}</span>.</p>
            <div class="mb-md-0 mt-4">
                <button class="btn btn-immersive btn-rounded" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Journée sécurité')}" title="contact"><i class="fas fa-envelope mr-2"></i>{{'Contact us' | translate}}</button>
            </div>
        </div>
        <!-- <div class="col-12 col-md-6 mb-md-0 px-4 mb-4">
            <picture>
                <source srcset="assets/safety-days-immersive-factory.webp" type="image/webp">
                <source srcset="assets/safety-days-immersive-factory.jpg" type="image/jpg">
                <img src="assets/safety-days-immersive-factory.jpg" class="block-rounded shadow" alt="Safety Days" title="Organize your Safety Day" loading="lazy">
            </picture>
        </div> -->
        <div class="col-12 col-md-6 p-0 m-0 video-banner" id="image-video1" (click)="video()" data-toggle="modal" data-target="#exampleModalCenter">
          <app-svg-icon id="test" [src]="'assets/youtube-play-circle-solid.svg'" [size]="'4rem'" class="fas youtube rounded-circle"></app-svg-icon>
        </div>
    </div>
</div>

<hr>
<!-- <hr class="m-0 p-0">

<div class="blue py-5">
	<div class="container">
		<div class="text-center mb-md-5">
			<span class="title">{{'Tarifs' | translate}}</span>
		</div>

		<div class="row justify-content-center pt-3">
      <div class="col-12 col-md-7 mb-4">
        <div class="block-pricing sub-middle">
          <div class="block-header">{{'Animation journée sécurité' | translate}}</div>
          <div class="block-content">
            <div class="block-prices py-4">
              <div class="px-0">
                <div class="prices-loading" *ngIf="loading"></div>
                <div class="prices-value animate__animated animate__fadeIn text-center" *ngIf="!loading">
                  <div class="price-workshop">
                    <span class="mr-1">{{basketService.currencySymbol}}</span>
                    <span>
                      <app-currency [currency]="basketService.currentCurrency" [currencyvalue]="1500"></app-currency>
                    </span>
                    <span class="ht"> {{'HT' | translate}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mb-4">
              <img src="assets/Tarifs_Abonnement_Animation_Journee_Securite.jpg" class="w-100" alt="image safety day animation">
            </div>
            <div class="mb-3">
              <div class="feature-point"><i class="fa fa-check-circle" aria-hidden="true"></i>
                <span>{{"Ateliers au choix" | translate }}</span>
                                      <span class="ml-1 fa-stack small dark-yellow" [routerLink]="language.navigateAccordingToLang(['/our-contributors'])" title="learn more">
                                          <i class="far fa-circle fa-stack-2x"></i>
                                          <i class="fas fa-info fa-stack-1x"></i>
                                      </span>
              </div>
              <div class="feature-point"><i class="fa fa-check-circle" aria-hidden="true"></i> {{"Votre consultant dédié" | translate }}</div>
              <div class="feature-point"><i class="fa fa-check-circle" aria-hidden="true"></i> {{"Son équipement VR complet" | translate }}</div>
              <div class="feature-point"><i class="fa fa-check-circle" aria-hidden="true"></i> {{"Environ 50 passages par consultant" | translate }}</div>
              <div class="feature-point"><i class="fa fa-check-circle" aria-hidden="true"></i> {{"Atelier PC offert pour votre journée" | translate }}</div>
            </div>
            <div class="text-center">
              <button class="btn btn-immersive d-inline-block" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Animation Journée sécurité')}">{{'Commander_' | translate}}</button>
            </div>
          </div>
        </div>
      </div>

		</div>
	</div>
</div>
<hr class="mt-0"> -->


<div class="container mb-5">
    <div class="text-center my-5 mb-5">
        <h2 class="title sub-bar">{{'Nos ateliers les plus populaires' | translate}}</h2>
    </div>
    <p class="text-justify-center">{{'Plus de 30 ateliers VR dédiés au' | translate}} <span class="text-bleu">{{'secteur HSE' | translate}}</span> {{'pour sensibiliser et former vos collaborateurs aux besoins spécifiques de chaque corps de métier :' | translate}} <i>{{'bonnes pratiques HSE, chute de plain pied, mauvaises postures, manutention, travail en hauteur, travail en espace confiné, circulation engins/piétons, risques chimiques etc..' | translate}}</i></p>
    <div *ngIf="listProducts" class="my-4">
        <div class="row ml-0 mr-0">
          <app-product-card class="col-md-4 mt-4"  *ngFor="let product of listProducts" [product]="product"></app-product-card>
        </div>
    </div>
    <div class="row">
        <div class="col-12 px-4 pt-4 mb-md-4 mb-4 text-center">
            <p class="text-justify-center">{{'Et bien plus encore ! Plongez au sein d’un' | translate}} <span class="text-bleu">{{'environnement virtuel au plus proche des réalités du terrain' | translate}}</span> {{'pour diffuser votre culture sécurité au travers d’une approche originale et ludique.' | translate}}.</p>
            <div class="mb-3 mb-md-0 mt-4">
                <button class="btn btn-immersive btn-rounded" [routerLink]="language.navigateAccordingToLang(['/content'])" title="catalog"><i class="fas fa-book-open mr-2"></i>{{'Consulter tous les ateliers' | translate}}</button>
            </div>
        </div>
    </div>
</div>



<hr class="m-0 p-0">


<div class="container py-5">
    <div class="text-center mb-md-5">
        <h2 class="title">{{'L’immersive Learning : une efficacité reconnue' | translate}}</h2>
    </div>
    <div class="row pt-4">
        <div class="col-12 text-justify-center">
            <p>{{'Une expérience virtuelle qui transcende les possibilités de la formation classique. Les études le disent : les personnes formées en réalité virtuelle sont en moyenne' | translate}} <span class="text-bleu">{{'275%* plus confiantes' | translate}}</span> {{'pour appliquer les connaissances acquises que lors de formations classiques. Les personnes formées auront donc de meilleures aptitudes en situation de risque, sauront reconnaître plus efficacement les risques et auront de meilleurs réflexes en cas d’accident' | translate}}.</p>
            <p class="bold subtitle mt-5">{{'Les personnes formées via l’apprentissage immersif sont :' | translate}}</p>
        </div>
    </div>
    <div class="row mt-2 mb-4 shadow">
        <div class="col-6 text-center separator p-4">
            <i class="fas fa-tachometer-alt apprentissage-immersif"></i>
            <p class="text-bleu mt-3 mb-1 text-uppercase">{{'4x plus rapides à former' | translate}}</p>
            <p>{{'qu’avec les méthodes de formation traditionnelles' | translate}}</p>
        </div>
        <div class="col-6 text-center separator p-4">
            <i class="fas fa-brain apprentissage-immersif"></i>
            <p class="text-bleu mt-3 mb-1 text-uppercase">{{'4x plus concentrées' | translate}}</p>
            <p>{{'que leurs homologues en e-learning' | translate}}</p>
        </div>
        <div class="col-6 text-center separator p-4">
            <i class="fas fa-heart apprentissage-immersif"></i>
            <p class="text-bleu mt-3 mb-1 text-uppercase">{{'3,75x plus connectées émotionnellement' | translate}}</p>
            <p>{{'que les apprenants en salle de formation' | translate}}</p>
        </div>
        <div class="col-6 text-center separator p-4">
            <i class="fas fa-graduation-cap apprentissage-immersif"></i>
            <p class="text-bleu mt-3 mb-1 text-uppercase">{{'275 % plus confiantes' | translate}}</p>
            <p>{{'pour appliquer les connaissances acquises' | translate}}</p>
        </div>
    </div>
    <div class="row pt-4">
        <div class="col-12 text-justify-center">
            <p>{{'*Selon l’étude “The Effectiveness of Virtual Reality Soft Skills Training in the Enterprise” de PWC.' | translate}}</p>
        </div>
    </div>
</div>


<hr class="m-0 p-0">

<div class="light-blue py-5">
<div class="container py-4">
    <div class="text-center mb-4">
        <h2 class="title">{{'Les avis de nos clients sont unanimes' | translate}}</h2>
    </div>
    <div class="row">
        <div class="col-12">
            <app-testimonials></app-testimonials>
        </div>
    </div>
</div>
</div>

<hr class="my-0">


<div class="container mt-5 mb-2">
    <div class="text-center mb-md-5">
        <h2 class="title">{{'Une offre illimitée' | translate}}</h2>
    </div>
    <div class="row py-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-4">
            <picture>
                <source srcset="assets/immersive-vr-catalog.webp" type="image/webp">
                <source srcset="assets/immersive-vr-catalog.jpg" type="image/jpg">
                <img src="assets/immersive-vr-catalog.jpg" class="block-rounded shadow w-100 w-sm-auto" alt="An immersive catalog" title="The VR Safety Day" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 mb-md-4 mb-4 text-justify justify-content-center">
            <p>{{'Avec' | translate}} <span class="bold">{{'l\'abonnement VR' | translate}}</span>, {{'bénéficiez d’un accès complet et illimité à notre catalogue de plus de' | translate}} <span class="bold">{{'30 exercices HSE en réalité virtuelle' | translate}}</span> {{'développés spécifiquement pour les besoins de chaque corps de métier' | translate}}.</p>
            <p>{{'Vos collaborateurs pourront ainsi être immergés dans une situation à risque ou dans une situation d’accident et apprendront à évoluer dans un' | translate}} <span class="bold">{{'environnement virtuel totalement réaliste' | translate}}</span>. {{'Grâce aux' | translate}} <span class="bold">{{'reportings' | translate}}</span>, {{'vous pourrez mesurer efficacement l’efficacité des ateliers et l’opérabilité de votre équipe' | translate}}.</p>
            <div class="mb-3 mb-md-0 mt-4">
                <button class="btn btn-immersive btn-rounded" [routerLink]="language.navigateAccordingToLang(['/subscription'])" title="subscribe"><i class="fas fa-sign-in-alt mr-2"></i>{{'Commander_' | translate}}</button>
            </div>
        </div>
    </div>

    <div class="row  mb-5">
        <div class="col-12 mb-2 py-4 px-5 text-center shadow">
            <p class="pt-4"><span class="text-bleu">{{'La journée sécurité' | translate}}</span> {{'s’adresse aux responsables HSE d’entreprises de services ou d’industrie en France et à l’étranger, préventeurs, organismes de formation désireux de mettre en place de nouveaux programmes de formation innovants' | translate}}.</p>
            <p class="bold">{{'Vous souhaitez en savoir plus ?' | translate}}</p>
            <div class="mb-3 mb-md-0 mt-2 pb-3">
                <button class="btn btn-immersive btn-rounded" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Journée sécurité')}" title="contact"><i class="fas fa-envelope mr-2"></i>{{'Nous contacter' | translate}}</button>
            </div>
        </div>
    </div>

</div>

<hr>

<div class="container my-5">
    <div class="text-center mb-5">
        <h2 class="title">{{'Quelques conseils pour organiser votre journée sécurité' | translate}}</h2>
    </div>
    <div class="row pt-4 d-flex align-items-center">
      <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 align-items-center">
          <p class="challenge"><app-svg-icon [src]="'assets/svg/1-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Le public :' | translate}}</p>
          <p class="text-justify">{{'Demandez-vous si vous souhaitez organiser une seule grosse journée pour former tout le monde, ou si vous préférez étaler cet événement sur plusieurs jours.' | translate}} {{'En souscrivant à un abonnement à un abonnement VR ou à une SafetyBox VR©, vous avez la possibilité d’organiser plusieurs séances avec de plus petits groupes pour le même prix.' | translate}}</p>
      </div>
      <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
          <picture>
              <source srcset="assets/man-vr-safety-day.webp" type="image/webp">
              <source srcset="assets/man-vr-safety-day.jpg" type="image/jpg">
              <img src="assets/man-vr-safety-day.jpg" class="block-rounded shadow w-100 w-sm-auto" alt="Man using a VR headset for 3D training" title="Organize your Safety Day" loading="lazy">
          </picture>
      </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4 d-flex align-items-center">
      <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
          <picture>
              <source srcset="assets/Casques_VR_HTC_Oculus.webp" type="image/webp">
              <source srcset="assets/Casques_VR_HTC_Oculus.jpg" type="image/jpg">
              <img src="assets/Casques_VR_HTC_Oculus.jpg" class="block-rounded shadow" alt="Autonomous VR headsets Oculus Quest 2 Vive Focus 3" title="VR headsets" loading="lazy">
          </picture>
      </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4">
            <p class="challenge"><app-svg-icon [src]="'assets/svg/2-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Le matériel :' | translate}}</p>
            <p class="text-justify">{{'Les ateliers que nous proposons sont jouables sur' | translate}} <span class="text-bleu">{{'casque de réalité virtuelle autonome' | translate}}</span>. {{'Pensez à vous équiper de casques si vous n’en possédez pas, cela restera un très bon investissement pour la suite. Sinon, vous avez la possibilité de souscrire à une prestation particulière dans laquelle nous nous occupons de vous fournir les casques et animons nous même l’atelier avec une personne formée (nous contacter pour plus d’informations sur cette prestation).' | translate}}</p>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4 d-flex align-items-center">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4">
            <p class="challenge"><app-svg-icon [src]="'assets/svg/3-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Le feedback :' | translate}}</p>
            <p class="text-justify"><span class="text-bleu">{{'Le backoffice' | translate}}</span> {{'fourni avec nos solutions vous permet d’analyser en temps réel l’efficacité de l’apprentissage, les points bloquants et d’identifier immédiatement les notions à éclaircir.' | translate}}</p>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/Reporting_Moyenne_Horizontal.webp" type="image/webp">
                <source srcset="assets/Reporting_Moyenne_Horizontal.jpg" type="image/jpg">
                <img src="assets/Reporting_Moyenne_Horizontal.jpg" class="block-rounded shadow" alt="Website backoffice: statistics and reporting" title="Feedback" loading="lazy">
            </picture>
        </div>
    </div>
</div>

<hr>

<div class="container mb-5">
    <div class="text-center my-5 mb-5">
        <h2 class="title sub-bar">{{'L’expertise d’Immersive Factory :' | translate}}</h2>
    </div>
</div>
<section class="text-center statistics">
    <div class="container">
        <div class="row shadow">
            <div class="col-12 col-md-4 py-5 separator">
                <div class="justify-content-center">
                    <div class="icon fa fas mb-3">
                        <app-svg-icon [src]="'assets/svg/users-solid.svg'" [size]="'30px'"></app-svg-icon>
                    </div>
                    <div>
                        <div class="nb mb-2">+100</div>
                        <div class="desc">{{'Clients nous font confiance' | translate}}</div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4 py-5 separator">
                <div class="justify-content-center">
                    <div class="icon fa fas mb-3">
                        <app-svg-icon [src]="'assets/svg/VR_Casque_Plein.svg'" [size]="'30px'"></app-svg-icon>
                    </div>
                    <div>
                        <div class="nb mb-2">+10 000</div>
                        <div class="desc">{{'Personnes formées' | translate}}</div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4 py-5 separator">
                <div class="justify-content-center">
                    <div class="icon fa fas mb-3">
                        <app-svg-icon [src]="'assets/svg/handshake-solid.svg'" [size]="'30px'"></app-svg-icon>
                    </div>
                    <div>
                        <div class="nb mb-2">+40</div>
                        <div class="desc">{{'Pays déploient nos solutions' | translate}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="container mt-5 mb-5 p-0">
  <div class="olivier-banner">
  <div class="gradient">
    <div class="row py-4 px-5">
      <div class="col-12 col-md-4 px-4 pt-2 pb-0">
          <picture>
              <source srcset="assets/Olivier_Pierre_Journee_Securite2.webp" type="image/webp">
              <source srcset="assets/Olivier_Pierre_Journee_Securite2.png" type="image/png">
              <img src="assets/Olivier_Pierre_Journee_Securite2.png" class="block-rounded mb-2" alt="Picture of Olivier Pierre CEO of Immersive Factory" title="Olivier Pierre" loading="lazy">
          </picture>
      </div>
      <div class="col-12 col-md-8 px-4 pt-4 olivier-quote">
          <hr class="hr-decorator">
          <p class="name pt-2">Olivier PIERRE</p>
          <p class="function">CEO - Immersive Factory</p>
          <p class="quote text-justify">{{'« Toutes nos formations ont été co-construites par des experts HSE et des industriels leaders dans les secteurs de la construction, de l’environnement, de l’énergie et de l’agro-alimentaire. Nous travaillons à partir des sites, de l’accidentologie et des risques de nos clients et écrivons des scénarios réalistes intégrant les procédures à respecter. L’arrivée de casques VR performants, tels que les autonomes, nous permet de rendre ces simulations immersives extrêmement fidèles aux situations rencontrées sur les lieux de travail. »' | translate}}</p>
      </div>
    </div>
    </div>
    </div>
</div>

<hr>

<div class="container mb-5 pb-1">
    <div class="text-center my-5 mb-5">
        <h2 class="title sub-bar">{{'Immersive Factory vous propose de nouveaux moyens d’animer vos formations en Réalité Virtuelle' | translate}}</h2>
    </div>
    <p class="text-justify weight">{{"Vous souhaitez rendre vos journées de sécurité plus engageantes ?" | translate}}</p>
    <p class="text-justify weight">{{"Nos modules de formation en réalité virtuelle sont le moyen idéal d'y parvenir. Réalistes, intéressants et attrayants, nous faisons en sorte que vos employés veuillent participer à la formation sur la sécurité avec envie et curiosité." | translate}}</p>
    <p class="text-justify weight">{{"Grâce à nos modules, vous serez en mesure de former vos employés sur la façon de rester en sécurité dans une variété de scénarios différents. Ils apprendront comment réagir dans des situations dangereuses, ce qui les rendra mieux équipés pour faire face à tout danger potentiel qu'ils pourraient rencontrer au travail. Immersive factory améliore le niveau de vos formations de prévention et vous permet de mieux impliquer les employés de votre entreprise. Nous mettons à disposition des supports très performants pour vos préventeurs HSE." | translate}}</p>
    <p class="text-justify weight">{{"Contactez-nous dès aujourd'hui et constatez par vous-même l'efficacité de nos modules de formation en VR !" | translate}}</p>
    <hr class="mt-4 mb-3" style="opacity:0.7">
    <p class="text-justify cgv">{{"Tout contenu de la plateforme est réservé à l’usage du client, pour la formation de ses salariés. Il ne peut être ni revendu sans l’accord préalable et écrit d’Immersive Factory, ni utilisé dans le cadre de formations ou d'animations payantes non dispensées par Immersive Factory, ses filiales et ses partenaires certifiés." | translate}}</p>
</div>

<hr>

<app-they-trust-us></app-they-trust-us>
